import {RouteObject} from 'react-router-dom';
import PublicLayout from './layouts/PublicLayout';
import { DefaultLayout } from '../containers';
import UnauthenticatedRoute from '../UnAuthRoute';
import AuthenticatedRoute from '../AuthRoute';
import RequireAuth from '../RequireAuth';
import { loadWithRetry } from '../components/Utility/loadWithRetry';
import TeamPulseRoute from './TeamPulseRoute';

const OnboardingWizard = loadWithRetry(() => import('../components/Onboarding/OnboardingWizard'));
const Login = loadWithRetry(() => import('../components/Login'));
const ResetPassword = loadWithRetry(() => import('../components/ResetPassword'));
const EmailVerification = loadWithRetry(() => import('../components/EmailVerification'));
const AccountCreation = loadWithRetry(() => import('../components/AccountCreation'));
const Register = loadWithRetry(() => import('../Pages/Register/Register'));
const RegisterWithEmail = loadWithRetry(() => import('../Pages/Register/RegisterWithEmail'));
const SharePlay = loadWithRetry(() => import('../Pages/SharePlay'));
const Followup = loadWithRetry(() => import('../Pages/Followup'));
const Success = loadWithRetry(() => import('../Pages/Success'));
const Error = loadWithRetry(() => import('../Pages/Error'));
const Page404 = loadWithRetry(() => import('../Pages/Page404'));
const Page500 = loadWithRetry(() => import('../Pages/Page500'));
const PipedriveIntegration = loadWithRetry(() => import('../components/PipedriveIntegration'));
const PipedriveRemoval = loadWithRetry(() => import('../components/PipedriveRemoval'));
const Dashboard = loadWithRetry(() => import('../components/Dashboard'));
const Deal = loadWithRetry(() => import('../components/Deal'));
const DealFullView = loadWithRetry(() => import('../components/Deal/DealFullView'));
const Settings = loadWithRetry(() => import('../components/Settings/Settings'));
const AccountFullView = loadWithRetry(() => import('../components/Account/AccountFullView'));
const Analytics = loadWithRetry(() => import('../components/Analytics/Analytics'));
const Playlists = loadWithRetry(() => import('../components/Playlists/PaylistThreePaneView'));
const Home = loadWithRetry(() => import('../components/Dashboard/Home'));
const Grid = loadWithRetry(() => import('../components/Grid'));
const MeetingFull = loadWithRetry(() => import('../components/Dashboard/MeetingThreePaneView'));
const Coaching = loadWithRetry(() => import('../components/Coaching/Coaching'));
const Agents = loadWithRetry(() => import('../components/Agents/Agents'));
const RolePlay = loadWithRetry(() => import('../components/RolePlay/RolePlay'));
const View = loadWithRetry(() => import('../Pages/View'));
const AnswerEngine = loadWithRetry(() => import('../components/Dashboard/AnswerEngine/AnswerEngine'));
const GenAIGrid = loadWithRetry(() => import('../components/Dashboard/GenAIGrid/GenAIGrid'));

export const PublicRoutes = (): RouteObject => {
    return {
        path: '/',
        element: <PublicLayout />,
        children: [
            {
                path: '/accountCreated',
                element: <OnboardingWizard />
            },
            {
                path: '/login',
                element: (
                    <UnauthenticatedRoute>
                        <Login />
                    </UnauthenticatedRoute>
                )
            },
            {
                path: '/reset',
                element: <ResetPassword/>
            },
            {
                path: '/verify',
                element: <EmailVerification/>
            },
            {
                path: '/created',
                element: <AccountCreation/>
            },
            {
                path: '/register',
                element: <Register/>
            },
            {
                path: '/registerWithEmail',
                element: <RegisterWithEmail/>
            },
            {
                path: '/play/:id',
                element: <SharePlay/>
            },
            {
                path: '/followup/:id',
                element: <Followup/>
            },
            {
                path: '/success',
                element: (
                    <Success />
                )
            },
            {
                path: '/error',
                element: <Error/>
            },
            {
                path: '/404',
                element: <Page404/>
            },
            {
                path: '/500',
                element: <Page500/>
            },
            {
                path: '/pipedriveintegrate',
                element: (
                    <AuthenticatedRoute>
                        <PipedriveIntegration />
                    </AuthenticatedRoute>
                )
            },
            {
                path: '/pipedriveremove',
                element: (
                    <AuthenticatedRoute>
                        <PipedriveRemoval />
                    </AuthenticatedRoute>
                )
            },
        ]

    }
}

export const PrivateRoutes = (): RouteObject => {
    return {
        path: '/',
        element: (
            <RequireAuth>
                <DefaultLayout />
            </RequireAuth>
        ),
        children: [
            {
                path: '/meetings/:id?',
                element: <Dashboard />
            },
            {
                path: '/answer-engine',
                element: <AnswerEngine />
            },
            {
                path: '/genai-grid',
                element: <GenAIGrid />
            },
            {
                path: '/deals',
                element: <Deal />
            },
            {
                path: '/meetings-full',
                element: <MeetingFull />
            },
            {
                path: '/home',
                element: <Home />
            },
            {
                path: '/grid',
                element: <Grid />
            },
            {
                path: '/settings',
                element: <Settings />
            },
            {
                path: '/deals-full',
                element: <DealFullView />
            },
            {
                path: '/accounts',
                element: <AccountFullView />
            },
            {
                path: '/analytics',
                element: (
                    <TeamPulseRoute>
                        <Analytics />
                    </TeamPulseRoute>
                )
            },
            {
                path: '/coaching',
                element: <Coaching />
            },
            {
                path: '/agents',
                element: <Agents />
            },
            {
                path: '/roleplay',
                element: <RolePlay />
            },
            {
                path: '/playlists/:id?',
                element: <Playlists />
            },
            {
                path: '/view/:id',
                element: <View />
            },
            {
                path: '/',
                element: <Home />
            },
        ]
    }
}
